import React from 'react';
import Five from '../layouts/five';
import R from '../rules';

class Rules extends React.Component {
    render() {
        const { params: { id } } = this.props;
        return <Five nbs="" bi="mina-con-cell.jpg">
            <R idSeason={id} />
        </Five>
    }
}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/information/rules.js